import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'
import { Row, Col, Checkbox, ToggleButton, ButtonToolbar, ToggleButtonGroup } from 'react-bootstrap'
import { Form, Input, isDefaultRequiredValue } from 'formsy-react-components'
import moment from 'moment'

import DataPrivDisclaimer from '../../DataPrivDisclaimer'
import Counter from '../../Counter'

import persIcon from '../../../images/icons/person_double_lg_gold.png'

import ReactGA from "react-ga";

import { Black, Center, GoldHeading, Icon, LogeButtonSlim, Cancel } from '../../GeneralStyle'

@inject(
  'bookingStore',
  'configStore',
  'userStore')

@observer
class ChooseParticipants extends Component {

  constructor(props) {
    super(props)
    this.state = {
      value: 1,
      slots: this.props.bookingStore.slots,
      maxSlots: this.props.userStore.maxSlots < this.props.bookingStore.golfCourseFreeSlots
        ? this.props.userStore.maxSlots
        : this.props.bookingStore.golfCourseFreeSlots,
      isInvite: this.props.bookingStore.isInvite,
      includeMyself: this.props.bookingStore.includeMyself,
      guests: this.props.bookingStore.guests,
      isTimeSet: false,
      isTimeError: false
    }
    this.setIsInvite = this.setIsInvite.bind(this)
    this.setIncludeMyself = this.setIncludeMyself.bind(this)
    this.setSlots = this.setSlots.bind(this)
    this.setBooking = this.setBooking.bind(this)
    this.addGuest = this.addGuest.bind(this)
    this.removeGuest = this.removeGuest.bind(this)
  }

  setSlots = (slots) => {
    this.props.bookingStore.setSlots(slots)
  }

  addGuest = (guestData) => {
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Add Guest - Booking Modal'
    });
    let guests = this.state.guests
    guests.push(guestData)
    this.setState({ guests: guests, slots: this.state.slots + 1 })
  }

  removeGuest = (guestNumber) => {
    ReactGA.event({
      category: 'Booking',
      action: 'Click',
      label: 'Remove Guest - Booking Modal'
    });
    let guests = this.state.guests
    guests.splice(guestNumber, 1)
    this.setState({ guests: guests, slots: this.state.slots - 1 })
  }

  setIsInvite = (isInvite) => {
    if( isInvite )
      this.setState({ guests: [], includeMyself: false, slots: 0, value: 2 })
    else {
      this.setState({ slots: this.props.bookingStore.slots, value: 1, isTimeSet: false })
    }
    this.setState({ isInvite: isInvite })
  }

  setIncludeMyself = () => {
    this.state.includeMyself
      ? this.setState({ includeMyself: false, slots: this.state.slots - 1 })
      : this.setState({ includeMyself: true, slots: this.state.slots + 1 })
  }

  setBooking = () => {
    if(this.state.isInvite) this.props.bookingStore.setSlots(this.state.slots)
    this.props.bookingStore.setGuests(this.state.guests)
    this.props.bookingStore.setIsInvite(this.state.isInvite)
    this.props.bookingStore.setIncludeMyself(this.state.includeMyself)
    this.props.bookingStore.setScreenNumber(2)

  }


  render() {
    const { bookingDate } = this.props.bookingStore

    const selectorButtons = (
      <div>
        <ButtonToolbar>
          <ToggleButtonGroup
            type="radio"
            name="options"
            value={this.state.value}
            onChange={this.onChange}>
            <ToggleButton onClick={() => this.setIsInvite(false)} value={1} bsStyle={"carousel-blue"}>Ohne Einladung</ToggleButton>
            <ToggleButton onClick={() => this.setIsInvite(true)} value={2} bsStyle={"carousel-blue"}>Mit Einladung</ToggleButton>
          </ToggleButtonGroup>
        </ButtonToolbar>
      </div>
    )

    const guestInput = (
      <Col sm={12} md={12} lg={12} className={"no-side-padding"}>
        <Form
          onSubmit={this.addGuest}
          layout={'vertical'}
          validateOnSubmit={true}
          validatePristine={false}>
          <Row>
            <Col lg={6}>
              <Input
                name="firstname"
                value=""
                type="text"
                placeholder="Vorname"
                validationErrors={{ isDefaultRequiredValue }}
                required
              />
            </Col>
            <Col lg={6}>
              <Input
                name="lastname"
                value=""
                type="text"
                placeholder="Nachname"
                validationErrors={{ isDefaultRequiredValue }}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Input
                name="genderTitle"
                value=""
                type="text"
                placeholder="Anrede"
                required
              />
            </Col>
            <Col lg={3}>
              <Input
                name="title"
                value=""
                type="text"
                placeholder="Titel"
              />
            </Col>
            <Col lg={6}>
              <Input
                name="company"
                value=""
                type="text"
                placeholder="Unternehmen"
                validationErrors={{ isDefaultRequiredValue }}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <Input
                name="phone"
                value=""
                type="text"
                placeholder="Telefonnummer"
                validationErrors={{ isDefaultRequiredValue }}
                required
              />
            </Col>
            <Col lg={6}>
              <Input
                name="email"
                value=""
                type="email"
                placeholder="E-Mail Adresse"
                validationErrors={{ isDefaultRequiredValue }}
                required
              />
            </Col>
          </Row>
          <Center marginTop={30} marginBottom={10}>
            <div style={{textAlign: "center", paddingBottom: 25}}><DataPrivDisclaimer isThirdParty={true} /></div>
            <LogeButtonSlim
              hoverFontColor={"white"}
              type="submit">Gast hinzufügen</LogeButtonSlim>
          </Center>
        </Form>
      </Col >
    )


    return (
      <div style={{paddingTop: 35, paddingBottom: 35}}>
        <Row style={{ marginTop: 25, marginBottom: 25 }}>
          <Col sm={2} md={2} lg={2}>
            <Icon margin={20} float={"right"} />
          </Col>
          <Col sm={10} md={10} lg={10}>
            <GoldHeading>Datum</GoldHeading>
            <Black>am {moment(bookingDate).locale("de").format('dddd[, den] Do MMMM YYYY')}</Black>

          </Col>
        </Row>
        <Row style={{ marginTop: 25, marginBottom: 25 }}>
          <Col sm={2} md={2} lg={2}>
            <Icon margin={20} icon={persIcon} float={"right"} />
          </Col>
          <Col sm={10} md={10} lg={10}>
            <GoldHeading>TeilnehmerInnen</GoldHeading>
            {!this.state.isInvite &&
              <div>
                <Row className={"row-eq-height"} style={{ marginTop: 20, marginBottom: 20 }}>
                  <Col sm={6} md={3} lg={3}>
                    <Black>Spielrechte: </Black>
                  </Col>
                  <Col sm={6} md={3} lg={3}>
                    <Counter count={this.state.slots} maxCount={this.state.maxSlots} setCount={this.setSlots} />
                  </Col>
                </Row>
              </div>}
          </Col>
        </Row>
        <Row>
          <Col sm={2} md={2} lg={2} />
          <Col sm={8} md={8} lg={8} className={"no-side-padding"}>>

            {selectorButtons}

            {this.state.isInvite &&
              <div>
                {this.state.maxSlots > 1 && this.state.guests.length < this.state.maxSlots &&
                  <Row style={{ marginTop: 25, marginBottom: 0 }}>
                    <Checkbox
                      checked={this.state.includeMyself}
                      onChange={this.setIncludeMyself}>
                      <Black>Ich persönlich werde auch teilnehmen</Black>
                    </Checkbox>
                  </Row>}

                {this.state.guests.map((guest, key) => {
                  return (
                    <Row key={key}>
                      <GoldHeading>Gast {key + 1}</GoldHeading>
                      <Black fontWeight={"bold"}>{guest.genderTitle} {guest.title} {guest.firstname} {guest.lastname}</Black>
                      <Black>{guest.company}</Black>
                      <Black>{guest.phone}</Black>
                      <Black>{guest.email}</Black>
                      <Cancel onClick={() => this.removeGuest(key)}>Gast entfernen</Cancel>
                    </Row>
                  )
                })}

                {this.state.slots < this.state.maxSlots &&
                    <Row style={{ marginBottom: 25 }} className={"no-side-padding"}>
                      <GoldHeading>Gast Hinzufügen</GoldHeading>
                      {guestInput}
                    </Row>}

              </div>}
          </Col>
          <Col sm={2} md={2} lg={2} />
        </Row>
        {((!this.state.isInvite) || (this.state.isInvite && this.state.guests.length > 0)) &&
          <Center marginTop={15} marginBottom={15}>
            <LogeButtonSlim
              hoverFontColor={"white"}
              onClick={this.setBooking}>
              Weiter</LogeButtonSlim>
          </Center>}
      </div>
    );
  }
}

ChooseParticipants.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
  configStore: MobxPropTypes.observableObject,
};

export default ChooseParticipants



// WEBPACK FOOTER //
// /src/components/internal/BookingModal/ChooseParticipants.js